import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from "react-router-dom";

import { ArrowBack } from '@mui/icons-material';
import { Tooltip, Fab } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { 
  ModelBase,
} from "@models";
import { 
  SpellList, 
  Spell,
  SpellLimitation,
} from "@dndModels";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";

import StringBox from "@components/input/strings/StringBox";
import ButtonBox from "@components/input/buttons/ButtonBox";
import LoadingBox from "@components/input/LoadingBox";

import SpellLimitInput from "@dndComponents/limitations/SpellLimitInput";
import ModelBaseDetails from "@dndComponents/ModelBaseDetails";
import CenteredMenu from "@components/input/menus/CenteredMenu";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function SpellListEdit() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [navigateTo, setNavigateTo] = useState<string | null>(null);
  const [obj, setObj] = useState<SpellList>(api.applyWorkingOn(new SpellList()));
  const [parse_string, setParseString] = useState("");
  const [change_time, setChangeTime] = useState(0);
  const [mode, setMode] = useState("Main");
  const [spells, setSpells] = useState<Spell[]>([]);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  useEffect(() => {
    if(!fetched) {
      load();
    }
  });
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const load = () => {
    setFetched(true);
    // debugger;
    setLoading(true);
    api.getSetOfObjects({ data_types: ["spell","spell_list"] }).then(res => {
      setSpells(res.spell as Spell[]);
      if (id && id !== "") {
        const spell_lists = res.spell_list as SpellList[];
        const new_obj = spell_lists.find(o => o._id === id);
        if (new_obj) {
          setObj(new_obj);
        }
      } 
      setLoading(false);
    });
  }

  // const submit = () => {
  //   if (api.user && 
  //     (api.user.admin || 
  //       obj._id === "" || 
  //       obj.owner_id === api.user._id)) {
  //     setProcessing(true);
  //     if (!api.user.admin || obj.source_books_old.filter(o => o.id === "Personal").length > 0) {
  //       obj.owner_id = api.user._id;
  //     } else if (api.user.admin && obj.source_books_old.filter(o => o.type === "Homebrew").length === 0) {
  //       obj.owner_id = "";
  //     }
  //     api.upsertObject("spell_list", obj).then(res => {
  //       setProcessing(false);
  //       setNavigateTo("/dandd/spell_list");
  //     });
  //   }
  // }

  const parse = () => {
    const pieces = parse_string.split("\n");
    console.log(parse_string);
    console.log(pieces);
    const new_obj = obj;
    console.log(new_obj);
    for (const piece of pieces) {
      let spell_name = piece;
      spell_name = common_util.replaceAll(spell_name, "’", "'");
      spell_name = common_util.replaceAll(spell_name, "*","");
      spell_name = common_util.replaceAll(spell_name, "(ritual)","");
      spell_name = spell_name.trim().toLowerCase();
      const spell_finder = spells.filter(o => 
        o.name.trim().toLowerCase() === spell_name && o.is_true_dominant);
      if (spell_finder.length === 1) {
        const spell_id = spell_finder[0]._id;
        if (!new_obj.limit.spell_ids.includes(spell_id)){
          new_obj.limit.spell_ids.push(spell_id);
        }
      } else if (spell_finder.length > 1) {
        console.error("Multiple Spells found");
        console.error(spell_name);
        console.error(spell_finder);
      } else if (spell_name.includes("Cantrip") || spell_name.includes("evel") || spell_name.length === 0) {
        // Ignore these lines
      } else {
        console.error("Unable to find spell when parsing list");
        console.log(piece);
        debugger;
      }
    }
    console.log(new_obj.limit.spell_ids);
    setObj(new_obj);
  }
  
  const height = window.innerHeight - 64;
  if (!fetched || loading) {
    return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  } else if (navigateTo !== null) {
    return <Navigate to={navigateTo} />;
  } else {
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 3
          }}>
          <Tooltip title={`Back to Spell Lists`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                setNavigateTo(`/dandd/${obj.data_type}`);
              }}>
              <ArrowBack/>
            </Fab>
          </Tooltip>
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <span className="header">
            { obj._id === "" ? `Create Spell List` : `Edit ${obj.name}` }
          </span>
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <StringBox 
            value={obj.name} 
            message={obj.name.length > 0 ? "" : "Name Invalid"} 
            name="Name"
            disabled={disabled}
            onBlur={(value: string) => {
              const new_obj = obj;
              new_obj.name = value;
              setObj(new_obj);
              setChangeTime(common_util.get_time_number());
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <CenteredMenu
            options={["Main","Limits"]}
            selected={mode}
            onSelect={setMode}
          />
        </Grid>
        { mode === "Main" ? 
          <>
            <Grid
              size={{
                xs: 12
              }}>
              <ModelBaseDetails
                obj={obj}
                change_time={change_time}
                disabled={disabled}
                onChange={(changed: ModelBase) => {
                  const new_obj = obj;
                  if (changed instanceof SpellList) {
                    new_obj.copy(changed);
                  }
                  setObj(new_obj);
                  setChangeTime(common_util.get_time_number());
                }}
              />
            </Grid>
          </>
        :
          <>
            <Grid
              size={{
                xs: 10
              }}>
              <StringBox
                name="Parse String"
                value={`${parse_string}`}
                multiline
                onBlur={(changed: string) => {
                  while (changed.includes(" No ")) {
                    changed = changed.replace(" No ", " No\n");
                  }
                  while (changed.includes(" Yes ")) {
                    changed = changed.replace(" Yes ", " Yes\n");
                  }
                  while (changed.includes("’")) {
                    changed = changed.replace("’", "'");
                  }
                  setParseString(changed);
                }}
              />
            </Grid>
            <Grid
              size={{
                xs: 2
              }}>
              <ButtonBox
                name="Parse"
                onClick={parse}
              />
            </Grid>
            <Grid
              size={{
                xs: 12
              }}>
              <SpellLimitInput 
                obj={obj.limit} 
                block_spell_lists={[obj._id]}
                onChange={(changed: SpellLimitation) => {
                  const new_obj = obj;
                  new_obj.limit = changed.clone();
                  setObj(new_obj);
                  setChangeTime(common_util.get_time_number());
                }}
              />
            </Grid>
          </>
        }
      </Grid>
    );
  }
}
